import {Dialog} from '@ui/overlays/dialog/dialog';
import {DialogHeader} from '@ui/overlays/dialog/dialog-header';
import {Trans} from '@ui/i18n/trans';
import {DialogBody} from '@ui/overlays/dialog/dialog-body';
import {useDialogContext} from '@ui/overlays/dialog/dialog-context';
import {DialogFooter} from '@ui/overlays/dialog/dialog-footer';
import {Button} from '@ui/buttons/button';
import {useNfo} from '@app/liens/use-nfo';
import {Skeleton} from '@ui/skeleton/skeleton';
import React from 'react';

interface LienIdDialogProps {
  id?: number;
  nfo?: string;
}

export function NfoDialog({id, nfo}: LienIdDialogProps) {
  const {close} = useDialogContext();
  const importItem = useNfo(id);
  const nfoContent = nfo || importItem.data?.nfo?.nfo || 'Aucun .nfo trouvé';

  if (!nfo && importItem.isLoading) {
    return <Skeleton className="max-w-200" />;
  }

  return (
    <Dialog size={'fullscreen'}>
      <DialogHeader>
        <Trans message=".NFO" />
      </DialogHeader>
      <DialogBody>
        <div
          className="overflow-hidden overflow-ellipsis"
          dangerouslySetInnerHTML={{__html: nfoContent}}
        ></div>
      </DialogBody>
      <DialogFooter>
        <Button onClick={() => close()}>
          <Trans message="Close" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
